"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _uiKit = require("@devsta/ui-kit");

var _BasicProfile = _interopRequireDefault(require("./BasicProfile"));

var _InviteUser = _interopRequireDefault(require("./InviteUser"));

var _SubscriptionDetails = _interopRequireDefault(require("./SubscriptionDetails"));

var _ContractAndTerms = _interopRequireDefault(require("./ContractAndTerms"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function EditOrganisationWizard(_ref) {
  var initialStage = _ref.initialStage,
      onBack = _ref.onBack;
  return _react.default.createElement(_uiKit.Wizard, {
    initialStage: initialStage,
    onBack: onBack
  }, _react.default.createElement(_BasicProfile.default, null), _react.default.createElement(_InviteUser.default, null), _react.default.createElement(_SubscriptionDetails.default, null), _react.default.createElement(_ContractAndTerms.default, null));
}

var _default = EditOrganisationWizard;
exports.default = _default;